import { BCMSRecord } from "@bcm-dev/bcms-vite";
import React from "react";
import CustomSelect, { CustomSelectItem } from "../..";
import "./styles.css";
export default function  CustomAccountSelect(props) {

    let onChange = (value, evt) => {
      if (props.onChange instanceof Function) {
        props.onChange(value, evt)
      }
    }
    let value = props.value;
    let disabledAccount = (account) => props.disabled ? account.id === props.disabled.id : false;
    let accounts = props.accounts ?? [{ id: 0 }];

    let accountItems = accounts.map((account, index) => {
      const dataPoint = (props.itemDataPointByIndex ?? false)
        ? `Account_${ index }` : `Account_${ account.id }`;

      return <CustomAccountSelectItem value={account} key={account.id} data-point={ dataPoint } disabled={disabledAccount(account)} />
    }, []);
    
    let dataPoint = props["data-point"] ?? "";
    dataPoint = dataPoint === "" ? (props["dataPoint"] ?? "") : dataPoint;
    // This allows us to add additional select items to the custom select
    // This is used in the StatementSearch, its an account select but
    // has an additional item for 'All Accounts'
    const numOfChildren = React.Children.count(props.children);
    if(numOfChildren > 0) {
      accountItems = numOfChildren > 1
        ? [ ...props.children ].concat(accountItems)
        : [ props.children ].concat(accountItems);
    }

    const hasAddButton = props.hasAddButton ?? false;
    
    // Set the "Add Account" button for adding unlinked accounts.
    if(hasAddButton === true) {
      accountItems = [
        <CustomSelectItem key={ `AddAccount` } value={ `AddAccount` }>{ `Add Account` }</CustomSelectItem>,
        ...accountItems
      ];
    }
  
    return (
      <CustomSelect className={ props.className ?? "" } value={value} onChange={onChange} disableAddAccountSelection={ true } data-point={dataPoint} active={ props.active }>
        { accountItems }
      </CustomSelect>
    )
  }
  
  function CustomAccountSelectItem(props) {
    //  Default values if no account is passed from properties; 
    let name = "[accountNickname]";
    let number = "[accountLastFour]";
    let balanceLabel = "Available";
    let balance = "$X.XX";
    let disabled = props.disabled === true ? true : false;
    const dataPoint =props["data-point"] ?props["data-point"] : props.dataPoint ?? "";
    const dataPointName = dataPoint ? { "data-point": `${ dataPoint }_Name` } : {};
    const dataPointNumber = dataPoint ? { "data-point": `${ dataPoint }_Number` } : {};
    const dataPointBalanceLabel = dataPoint ? { "data-point": `${ dataPoint }_Balance_Label` } : {};
    const dataPointBalance = dataPoint ? { "data-point": `${ dataPoint }_Balance` } : {};

    //Set values to account properties if account is passed
    if (props.value instanceof BCMSRecord) {
      name = props.value.nickname;
      number = props.value.number;
      balanceLabel = props.value.balanceLabel;

      // Unlinked accounts show a different ui.
      if(props.value.type !== "unlinked") {
        balance = props.value.balanceLabel === "Available"
        ? props.value.availableBalance.format()
        : props.value.currentBalance.format();
      }

      // "Line of credit" accounts are an additional type of account added
      // on top of what is currently supported.
      if(props.value.type === "loc") {
        balanceLabel = props.value.secondaryBalanceLabel;
        balance = props.value.availableCredit.format();
      }
    }

    // Unlinked accounts show a different ui.
    if(props.value) {
      if(props.value.type === "unlinked") {
        balanceLabel = "Unlinked Account";
        balance = "";
      }
    }

    return (
      <CustomSelectItem value={props.value} className="flex-container flex-vertical account-name-num-select" disabled={disabled}>
        <div className="account-select-account-details" data-point={dataPoint}>
          <p>
            <span { ...dataPointName }>{ name }</span> - <span { ...dataPointNumber }>{ number }</span>
          </p>
          <p>
            <span { ...dataPointBalanceLabel }>{ balanceLabel }</span> <span { ...dataPointBalance }>{ balance }</span>
          </p>
        </div>
      </CustomSelectItem>
    )
  }